import React from 'react';
// @ts-ignore
import OnlineRetailers from './online-retailers';
// @ts-ignore
import DealerMap from './dealer-map';
// @ts-ignore
import {HeaderHeight} from './../../themes/kent/utilities/constants';
//@ts-ignore
import ScrollFadeIn from './../scroll-fade/./scroll-fade';

interface IProps {
  brand?:string;
  enRetailers?:any;
  euRetailers?:any;
  ukRetailers?:any;
  auRetailers?:any;
  ruRetailers?:any;
  deRetailers?:any;
}

/**
 *
 * DealerLocator Component
 * @extends {React.Component}
 */

//@ts-ignore
class DealerLocator extends React.Component<IProps> {
  public render(): JSX.Element {
    let backgroundColor:string = '#000000';
    return (
      <ScrollFadeIn>
        <div style={{paddingTop:HeaderHeight+"px", backgroundColor:backgroundColor}}>
          <OnlineRetailers
            enRetailers={this.props.enRetailers}
            euRetailers={this.props.euRetailers}
            ukRetailers={this.props.ukRetailers}
            auRetailers={this.props.auRetailers}
            ruRetailers={this.props.ruRetailers}
            deRetailers={this.props.deRetailers}
          />
          <div style={{height:'75vh', position:'relative', overflow:'hidden'}}>
            <DealerMap
              brand={this.props.brand}
              //hideSearchBar={true}
              highlightPreferredRetailers={true}
            />
          </div>
        </div>
      </ScrollFadeIn>
    );
  }
}

//@ts-ignore
export default DealerLocator;
